export type FeedbackQuestionType = 'rating' | 'text' | 'select';

export interface FeedbackQuestion {
  id: string;
  type: FeedbackQuestionType;
  label: string;
  description?: string;
  required: boolean;
  options?: string[];
  min?: number;
  max?: number;
}

export const FEEDBACK_QUESTIONS: FeedbackQuestion[] = [
  {
    id: 'overall_satisfaction',
    type: 'rating',
    label: 'Overall Satisfaction',
    description: 'How satisfied are you with Queri overall?',
    required: true,
    min: 1,
    max: 5,
  },
  {
    id: 'most_useful_feature',
    type: 'select',
    label: 'Most Useful Feature',
    description: 'Which feature do you find most useful?',
    required: true,
    options: [
      'Document Chat',
      'Document Review',
      'Playbooks',
      'Knowledge Database',
      'Meeting Assistant',
    ],
  },
  {
    id: 'ease_of_use',
    type: 'rating',
    label: 'Ease of Use',
    description: 'How easy is Queri to use?',
    required: true,
    min: 1,
    max: 5,
  },
  {
    id: 'missing_features',
    type: 'text',
    label: 'Missing Features',
    description: 'Are there any features you wish Queri had?',
    required: false,
  },
  {
    id: 'additional_comments',
    type: 'text',
    label: 'Additional Comments',
    description: 'Any other feedback you would like to share?',
    required: false,
  },
];
